import React from "react";
import { Link, useLocation } from "react-router-dom";
import { DOCS_MENU_ITEMS } from "../constants";

import "./index.scss";


const Sidebar = ({ selectedItem }) => {
	const { pathname } = useLocation();

	return <div className="docs-sidebar-wrapper">

		<div className="docs-sidebar">
			<div className="docs-sidebar-body">
				{DOCS_MENU_ITEMS.map(({ label, value, type, icon }) => (
						<Link
							to={`${pathname}?section=${value}`}
							replace
							key={value}
							className={value === selectedItem ? 'active' : ''}
							style={{ marginLeft: type === 'sub' ? '1rem' : type === 'subsub' ? '2rem' : '' }}
						>
							{icon}
							<span>{label}</span>
						</Link>
				))}
			</div>
		</div>

	</div>
}

export default Sidebar;
